import React from "react";
import { Box, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

function IrrelevantBadge() {
    const { t } = useTranslation("common");

    return (
        <Tooltip title={t("search.licensePlateWasMarkedAsIrrelevant")}>
            <Box
                sx={{
                    position: 'absolute',
                    top: -8,
                    right: -8,
                    // todo use theme colors
                    backgroundColor: '#d32f2f',
                    color: 'white',
                    borderRadius: '50%',
                    width: 20,
                    height: 20,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.65rem',
                    fontWeight: '700',
                    border: '2px solid white',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    zIndex: 1,
                    cursor: 'help',
                }}
            >
                !
            </Box>
        </Tooltip>
    );
};

export default IrrelevantBadge;
